const partnerships = {
  title: 'responsibleBusiness.partnershipsTitle',
  titleIcon: {
    url: '/icons/arrow-button-right.svg',
    alternative: '',
  },
  items: [
    {
      title: 'responsibleBusiness.partnerships[0].title',
      text: 'responsibleBusiness.partnerships[0].text',
      image: {
        url: '/images/icon-partnership.png',
      },
    },
    {
      title: 'responsibleBusiness.partnerships[1].title',
      text: 'responsibleBusiness.partnerships[1].text',
      image: {
        url: '/images/icon-partnership.png',
      },
    },
  ],
}

const ratings = {
  title: 'responsibleBusiness.ratingsTitle',
  titleIcon: {
    url: '/icons/arrow-button-right.svg',
    alternative: '',
  },
  items: [
    {
      title: 'responsibleBusiness.ratings[0].title',
      text: 'responsibleBusiness.ratings[0].text',
      image: {
        url: '/images/icon-rating.png',
      },
    },
    {
      title: 'responsibleBusiness.ratings[1].title',
      text: 'responsibleBusiness.ratings[1].text',
      image: {
        url: '/images/icon-rating.png',
      },
    },
  ],
}

const distinctions = {
  title: 'responsibleBusiness.distinctionsTitle',
  titleIcon: {
    url: '/icons/arrow-button-right.svg',
    alternative: '',
  },
  items: [
    {
      title: 'responsibleBusiness.distinctions[0].title',
      text: 'responsibleBusiness.distinctions[0].text',
      image: {
        url: '/images/icon-distinction.png',
      },
    },
    {
      title: 'responsibleBusiness.distinctions[1].title',
      text: 'responsibleBusiness.distinctions[1].text',
      image: {
        url: '/images/icon-distinction.png',
      },
    },
  ],
}

const keyActivitiesBoxes = [
  {
    title: 'responsibleBusiness.section5.boxes[0].title',
    text: 'responsibleBusiness.section5.boxes[0].text',
    image: {
      url: '/images/logo-multisport-fundacja.png',
      alternative: 'responsibleBusiness.section5.boxes[0].image.alternative',
      width: '232',
      height: '70',
    },
  },
  {
    title: 'responsibleBusiness.section5.boxes[1].title',
    text: 'responsibleBusiness.section5.boxes[1].text',
    image: {
      url: '/images/logo-dobry-multiuczynek.png',
      alternative: 'responsibleBusiness.section5.boxes[1].image.alternative',
      width: '257',
      height: '60',
    },
  },
  {
    title: 'responsibleBusiness.section5.boxes[2].title',
    text: 'responsibleBusiness.section5.boxes[2].text',
    image: {
      url: '/images/logo-z-natura-fair-play.png',
      alternative: 'responsibleBusiness.section5.boxes[2].image.alternative',
      width: '165',
      height: '61',
    },
  },
]

const companyValues = {
  items: [
    {
      title: 'responsibleBusiness.companyValues[0].title',
      image: {
        url: '/icons/icon-agency.svg',
        alternative: 'responsibleBusiness.companyValues[0].title',
      },
    },
    {
      title: 'responsibleBusiness.companyValues[1].title',
      image: {
        url: '/icons/icon-respect.svg',
        alternative: 'responsibleBusiness.companyValues[1].title',
      },
    },
    {
      title: 'responsibleBusiness.companyValues[2].title',
      image: {
        url: '/icons/icon-responsibility.svg',
        alternative: 'responsibleBusiness.companyValues[2].title',
      },
    },
    {
      title: 'responsibleBusiness.companyValues[3].title',
      image: {
        url: '/icons/icon-development.svg',
        alternative: 'responsibleBusiness.companyValues[3].title',
      },
    },
    {
      title: 'responsibleBusiness.companyValues[4].title',
      image: {
        url: '/icons/icon-cooperation.svg',
        alternative: 'responsibleBusiness.companyValues[4].title',
      },
    },
  ],
}

const chainOfValues = [
  {
    text: 'responsibleBusiness.businessModel.chain[0].text',
    textCustom: 'responsibleBusiness.businessModel.chain[0].textCustom',
    color: '#BA8BF5',
    boxes: [
      {
        items: [
          {
            img: {
              url: '/icons/icon-organic.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[0].boxes[0].items[0].text',
          },
          {
            img: {
              url: '/icons/filter-organization-1.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[0].boxes[0].items[1].text',
          },
          {
            img: {
              url: '/icons/icon-laptop.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[0].boxes[0].items[2].text',
          },
          {
            img: {
              url: '/icons/icon-crowd.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[0].boxes[0].items[3].text',
          },
        ],
      },
    ],
  },
  {
    text: 'responsibleBusiness.businessModel.chain[1].text',
    textCustom: 'responsibleBusiness.businessModel.chain[1].textCustom',
    color: '#9C5BEF',
    boxes: [
      {
        items: [
          {
            img: {
              url: '/icons/icon-globe.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[1].boxes[0].items[0].text',
          },
          {
            img: {
              url: '/icons/icon-pin.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[1].boxes[0].items[1].text',
          },
        ],
      },
      {
        items: [
          {
            img: {
              url: '/icons/icon-nodes.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[1].boxes[1].items[0].text',
          },
          {
            img: {
              url: '/icons/icon-nodes-1.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[1].boxes[1].items[1].text',
          },
          {
            img: {
              url: '/icons/icon-nodes-2.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[1].boxes[1].items[2].text',
          },
        ],
      },
    ],
  },
  {
    text: 'responsibleBusiness.businessModel.chain[2].text',
    textCustom: 'responsibleBusiness.businessModel.chain[2].textCustom',
    color: '#7C49BE',
    boxes: [
      {
        items: [
          {
            img: {
              url: '/icons/icon-hexagon-user.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[2].boxes[0].items[0].text',
          },
          {
            img: {
              url: '/icons/icon-recycle.svg',
            },
            text: 'responsibleBusiness.businessModel.chain[2].boxes[0].items[1].text',
          },
        ],
      },
    ],
  },
]

const BSPillars = {
  title: 'responsibleBusiness.sectionPillars.header',
  subTitle: 'responsibleBusiness.sectionPillars.subHeader',
  items: [
    {
      symbol: 'e',
      title: 'responsibleBusiness.sectionPillars.e.title',
      label: 'responsibleBusiness.sectionPillars.e.label',
      heading: 'responsibleBusiness.sectionPillars.e.heading',
      text: 'responsibleBusiness.sectionPillars.e.text',
      source: {
        text: 'responsibleBusiness.sectionPillars.e.source.text',
        link: 'responsibleBusiness.sectionPillars.e.source.link',
      },
      img: {
        title: 'responsibleBusiness.sectionPillars.e.img.title',
        url: 'responsibleBusiness.sectionPillars.e.img.url',
        alternative: 'responsibleBusiness.sectionPillars.e.img.alternative',
        width: '754',
        height: '766',
      },
    },
    {
      symbol: 's',
      title: 'responsibleBusiness.sectionPillars.s.title',
      label: 'responsibleBusiness.sectionPillars.s.label',
      heading: 'responsibleBusiness.sectionPillars.s.heading',
      text: 'responsibleBusiness.sectionPillars.s.text',
      source: {
        text: 'responsibleBusiness.sectionPillars.s.source.text',
        link: 'responsibleBusiness.sectionPillars.s.source.link',
      },
      img: {
        title: 'responsibleBusiness.sectionPillars.s.img.title',
        url: 'responsibleBusiness.sectionPillars.s.img.url',
        alternative: 'responsibleBusiness.sectionPillars.s.img.alternative',
        width: '798',
        height: '798',
      },
    },
    {
      symbol: 'g',
      title: 'responsibleBusiness.sectionPillars.g.title',
      label: 'responsibleBusiness.sectionPillars.g.label',
      heading: 'responsibleBusiness.sectionPillars.g.heading',
      text: 'responsibleBusiness.sectionPillars.g.text',
      source: {
        text: 'responsibleBusiness.sectionPillars.g.source.text',
        link: 'responsibleBusiness.sectionPillars.g.source.link',
      },
      img: {
        title: 'responsibleBusiness.sectionPillars.g.img.title',
        url: 'responsibleBusiness.sectionPillars.g.img.url',
        alternative: 'responsibleBusiness.sectionPillars.g.img.alternative',
        width: '784',
        height: '766',
      },
    },
  ],
}

const moreAbout = {
  ourApproach: [
    {
      text: 'responsibleBusiness.section1.moreAbout.companyArticlesAssociation.text',
      to: 'responsibleBusiness.section1.moreAbout.companyArticlesAssociation.to',
    },
    {
      text: 'responsibleBusiness.section1.moreAbout.companyValues.text',
      to: 'responsibleBusiness.section1.moreAbout.companyValues.to',
    },
    {
      text: 'responsibleBusiness.section1.moreAbout.bCorp.text',
      to: 'responsibleBusiness.section1.moreAbout.bCorp.to',
    },
    {
      text: 'responsibleBusiness.section1.moreAbout.ethicsCode.text',
      to: 'responsibleBusiness.section1.moreAbout.ethicsCode.to',
    },
    {
      text: 'responsibleBusiness.section1.moreAbout.irregularities.text',
      to: 'responsibleBusiness.section1.moreAbout.irregularities.to',
    },
  ],
  sustainableDevelopment: [
    {
      text: 'responsibleBusiness.businessModel.moreAbout.summary.text',
      to: 'responsibleBusiness.businessModel.moreAbout.summary.to',
    },
    {
      text: 'responsibleBusiness.businessModel.moreAbout.businessModel.text',
      to: 'responsibleBusiness.businessModel.moreAbout.businessModel.to',
    },
    {
      text: 'responsibleBusiness.businessModel.moreAbout.keyStakeholders.text',
      to: 'responsibleBusiness.businessModel.moreAbout.keyStakeholders.to',
    },
    {
      text: 'responsibleBusiness.businessModel.moreAbout.significanceMatrix.text',
      to: 'responsibleBusiness.businessModel.moreAbout.significanceMatrix.to',
    },
    {
      text: 'responsibleBusiness.businessModel.moreAbout.reportArchive.text',
      to: 'responsibleBusiness.businessModel.moreAbout.reportArchive.to',
    },
  ],
  strategy: [
    {
      text: 'responsibleBusiness.sectionPillars.moreAbout.betterLife.text',
      to: 'responsibleBusiness.sectionPillars.moreAbout.betterLife.to',
    },
    {
      text: 'responsibleBusiness.sectionPillars.moreAbout.bsPillars.text',
      to: 'responsibleBusiness.sectionPillars.moreAbout.bsPillars.to',
    },
    {
      text: 'responsibleBusiness.sectionPillars.moreAbout.ourPriorities.text',
      to: 'responsibleBusiness.sectionPillars.moreAbout.ourPriorities.to',
    },
    {
      text: 'responsibleBusiness.sectionPillars.moreAbout.keyActivities.text',
      to: 'responsibleBusiness.sectionPillars.moreAbout.keyActivities.to',
    },
    {
      text: 'responsibleBusiness.sectionPillars.moreAbout.esgComitee.text',
      to: 'responsibleBusiness.sectionPillars.moreAbout.esgComitee.to',
    },
    {
      text: 'responsibleBusiness.sectionPillars.moreAbout.strategyArchive.text',
      to: 'responsibleBusiness.sectionPillars.moreAbout.strategyArchive.to',
    },
  ],
  partnerships: [
    {
      text: 'responsibleBusiness.section6.moreAbout.partnerships.text',
      to: 'responsibleBusiness.section6.moreAbout.partnerships.to',
    },
    {
      text: 'responsibleBusiness.section6.moreAbout.ratings.text',
      to: 'responsibleBusiness.section6.moreAbout.ratings.to',
    },
    {
      text: 'responsibleBusiness.section6.moreAbout.awards.text',
      to: 'responsibleBusiness.section6.moreAbout.awards.to',
    },
  ],
  keyActivities: [
    {
      text: 'responsibleBusiness.section5.moreAbout.importantActivities.text',
      to: 'responsibleBusiness.section5.moreAbout.importantActivities.to',
    },
    {
      text: 'responsibleBusiness.section5.moreAbout.multisport.text',
      to: 'responsibleBusiness.section5.moreAbout.multisport.to',
    },
    {
      text: 'responsibleBusiness.section5.moreAbout.multiuczynek.text',
      to: 'responsibleBusiness.section5.moreAbout.multiuczynek.to',
    },
    {
      text: 'responsibleBusiness.section5.moreAbout.fairPlay.text',
      to: 'responsibleBusiness.section5.moreAbout.fairPlay.to',
    },
    {
      text: 'responsibleBusiness.section5.moreAbout.pressOffice.text',
      to: 'responsibleBusiness.section5.moreAbout.pressOffice.to',
    },
  ],
}

export {
  partnerships,
  ratings,
  distinctions,
  keyActivitiesBoxes,
  companyValues,
  chainOfValues,
  BSPillars,
  moreAbout,
}
